
import MessageTypeLogic from '@/services/messageTypeLogic'
import { defineComponent, computed, ref, watch } from 'vue'
import { RouteLocationRaw } from 'vue-router'
import { MessageTypes } from '@/constants/messageTypes'

/**
 * メッセージ履歴 内容表示コンポーネント
 */
export default defineComponent({
  name: 'ApplicantMessageHistoryBody',
  components: {},
  props: {
    // 本文
    body: {
      type: String,
      required: true,
    },
    // 申請基本ID
    requestHeaderId: {
      type: Number,
      required: true,
    },
    // メッセージ種別
    messageType: {
      type: Number,
      required: true,
    },
    // メッセージID
    messageId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const logic = computed(() => {
      return new MessageTypeLogic(props.messageType, props.requestHeaderId)
    })
    const displayBody = ref<string>('')
    const messageBody = ref<string>('')
    const to = ref<RouteLocationRaw | null>(null)
    const isTooltip = ref<boolean>(true)

    watch(
      () => [logic, props.messageId],
      async () => {
        // 初期化
        displayBody.value = ''
        messageBody.value = ''
        to.value = null

        // ロジック変更時、表示文字列を変える。固定文字があればそれを採用する
        displayBody.value = (await logic.value.getFixedHistoryBody(props.messageId)) ?? logic.value.getTypeName()
        messageBody.value = props.body
        isTooltip.value = logic.value.isDisplayTooltip()
        // リンク先の取得
        if (
          props.messageType === MessageTypes.APPLICANT_REGIST_PROXIMITY ||
          props.messageType === MessageTypes.PROXY_REGIST_PROXIMITY_NOTICE
        ) {
          to.value = {
            name: 'ApplicantMessageHistoryRegister',
            params: {
              request_header_id: props.requestHeaderId,
            },
          }
        } else {
          to.value = {
            name: 'ApplicantMessageHistoryDetail',
            params: {
              request_header_id: props.requestHeaderId,
              message_type: props.messageType,
              message_id: props.messageId,
            },
          }
        }
      },
      { immediate: true, deep: true }
    )

    return {
      displayBody,
      messageBody,
      to,
      isTooltip,
    }
  },
})
